import React, { HTMLProps } from 'react';

export const Link: React.FC<{ linkColor?: 'black' | 'green' } & HTMLProps<HTMLAnchorElement>> = ({
    linkColor = 'black',
    children,
    className,
    ...props
}) => {
    return (
        <a
            className={`${className} ${
                linkColor === 'green'
                    ? 'text-bnd-green hover:text-bnd-green-hover'
                    : 'text-bnd-black-80 hover:text-bnd-black'
            }`}
            {...props}
        >
            {children}
        </a>
    );
};
